export const createSchemaOrganization = () => (
  {
    '@context': 'https://schema.org/',
    '@type': 'Organization',
    name: 'Wag!',
    alternateName: 'WagWalking',
    url: 'https://wagwalking.com',
    sameAs: [
      'https://www.facebook.com/WagWalking/',
      'https://twitter.com/WagWalking',
      'https://www.instagram.com/wag/',
      'https://www.linkedin.com/company/wag-labs-inc-/',
      'https://www.pinterest.com/wagwalking/',
    ],
    logo: {
      '@type': 'ImageObject',
      url: 'https://wagwalking.com/img/layout/logo.png',
      width: 105,
      height: 40,
    },
  }
);
